<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header pb-0 d-flex justify-content-between align-items-center">
            <h6>Plano de Fábrica</h6>
            <div class="d-flex gap-3 align-items-center">
              <div class="d-flex align-items-center gap-1">
                <div style="width: 16px; height: 16px; background-color: #dc3545; border-radius: 3px;"></div>
                <small>Ocupado</small>
              </div>
              <div class="d-flex align-items-center gap-1">
                <div style="width: 16px; height: 16px; background-color: #28a745; border-radius: 3px;"></div>
                <small>Disponible</small>
              </div>
              <!-- <div class="d-flex align-items-center gap-1">
                <div
                  style="width: 16px; height: 16px; background-color: #ffffff; border: 1px solid #6c757d; border-radius: 3px;">
                </div>
                <small>Sin asignar</small>
              </div> -->
              <!--  <button 
                @click="resetAll" 
                class="btn btn-primary btn-sm"
              >
                Resetear Todo
              </button> -->
            </div>
          </div>
          <div class="card-body">
            <div class="factory-container" style="overflow: scroll;">

              <!-- Left side sections -->
              <div class="factory-section" style="top: 30px; left: 30px; width: 200px; height: 68px;"
                :class="getSectionClass('M21')" @click="openModalDetails('M21')">
                M21
              </div>

              <div class="factory-section" style="top: 110px; left: 30px; width: 200px; height: 68px;"
                :class="getSectionClass('M20')" @click="openModalDetails('M20')">
                M20
              </div>

              <!-- M19 and M18 -->
              <div class="factory-section" style="top: 208px; left: 30px; width: 136px; height: 72px;"
                :class="getSectionClass('M19')"  @click="openModalDetails('M19')">
                M19
              </div>

              <div class="factory-section" style="top: 208px; left: 173px; width: 57px; height: 72px;"
                :class="getSectionClass('M18')" @click="openModalDetails('M18')">
                M18
              </div>


              <!-- Bottom sections -->
              <div class="factory-section" style="left: 30px; width: 136px; height: 34px; top: 308px;"
                :class="getSectionClass('M12')" @click="openModalDetails('M12')" >
                M12
              </div>

              <div class="factory-section" style="left: 30px; width: 136px; height: 34px; top: 352px;"
                :class="getSectionClass('M11')" @click="openModalDetails('M11')"  >
                M11
              </div>

              <div class="factory-section" style="left: 30px; width: 136px; height: 34px; top: 397px;"
                :class="getSectionClass('M10')" @click="openModalDetails('M10')">
                M10
              </div>

              <div class="factory-section" style="width: 57px; height: 79px; top: 308px; left: 173px;"
                :class="getSectionClass('M13')"  @click="openModalDetails('M13')">
                M13
              </div>


              <!-- SEC sections -->
              <div class="factory-section" style="top: 30px; left: 260px; width: 37px; height: 168px;"
                :class="getSectionClass('SEC4')"  @click="openModalDetails('SEC4')" >
                SEC 4
              </div>

              <div class="factory-section" style="top: 30px; left: 304px; width: 37px; height: 168px;"
                :class="getSectionClass('SEC3')" @click="openModalDetails('SEC3')"  >
                SEC 3
              </div>

              <div class="factory-section" style="top: 30px; left: 348px; width: 37px; height: 168px;"
                :class="getSectionClass('SEC2')" @click="openModalDetails('SEC2')">
                SEC 2
              </div>

              <div class="factory-section" style="top: 30px; left: 392px; width: 37px; height: 168px;"
                :class="getSectionClass('SEC1')" @click="openModalDetails('SEC1')" >
                SEC 1
              </div>

              <div class="factory-section" style="top: 30px; left: 436px; width: 60px; height: 136px;"
                :class="getSectionClass('M22')" @click="openModalDetails('M22')">
                M22
              </div>

              <div class="factory-section" style="top: 208px; left: 259px; width: 236px; height: 72px;"
                :class="getSectionClass('M18')" @click="openModalDetails('M18')" >
                M18
              </div>


              <!-- Hornos (Circular sections) -->

              <div class="factory-section circular" style="top: 223px; left: 580px; width: 80px; height: 80px;"
                :class="getSectionClass('001')"  @click="openModalDetails('001')"  >
                HORNO 1
              </div>

              <div class="factory-section circular" style="top: 139px; left: 580px; width: 80px; height: 80px;"
                :class="getSectionClass('002')" @click="openModalDetails('002')"  >
                HORNO 2
              </div>

              <div class="factory-section circular" style="top: 223px; left: 688px; width: 80px; height: 80px;"
                :class="getSectionClass('003')" @click="openModalDetails('003')"  >
                HORNO 3
              </div>

              <div class="factory-section circular" style="top: 140px; left: 688px; width: 80px; height: 80px;"
                :class="getSectionClass('004')" @click="openModalDetails('004')"   >
                HORNO 4
              </div>

              <div class="factory-section circular" style="top: 97px; left: 867px; width: 80px; height: 80px;"
                :class="getSectionClass('005')" @click="openModalDetails('005')" >
                HORNO 5
              </div>

              <div class="factory-section circular" style="top: 6px; left: 756px; width: 80px; height: 80px;"
                :class="getSectionClass('006')"   @click="openModalDetails('006')" >
                HORNO 6
              </div>

             


           

           


              <div class="factory-section" style="top: 206px; left: 788px; width: 60px; height: 40px;"
                :class="getSectionClass('M27')"  @click="openModalDetails('M27')" >
                M27
              </div>

              <div class="factory-section" style="top: 274px; left: 788px; width: 60px; height: 40px;"
                :class="getSectionClass('M26')" @click="openModalDetails('M26')" >
                M26
              </div>

              <div class="factory-section" style="top: 187px; left: 864px; width: 30px; height: 59px;"
                :class="getSectionClass('M30')" @click="openModalDetails('M30')"  >
                M30
              </div>

              <div class="factory-section" style="top: 274px; left: 856px; width: 60px; height: 61px;"
                :class="getSectionClass('M31')" @click="openModalDetails('M31')"   >
                M31
              </div>


              <div class="factory-section" style="top: 323px; width: 129px; height: 28px; left: 696px;"
                :class="getSectionClass('M25')"  @click="openModalDetails('M25')"  >
                M25
              </div>

              <div class="factory-section" style="top: 355px; left: 696px; width: 51px; height: 28px;"
                :class="getSectionClass('M23')" @click="openModalDetails('M23')" >
                M23
              </div>

              <div class="factory-section" style="top: 355px; left: 768px; width: 51px; height: 28px;"
                :class="getSectionClass('M24')"  @click="openModalDetails('M24')"  >
                M24
              </div>

            
              <div class="factory-section" style="top: 86px; left: 954px; width: 40px; height: 160px;"
                :class="getSectionClass('M33')" @click="openModalDetails('M33')"   >
                M33
              </div>

              <div class="factory-section" style="top: 86px; left: 1018px; width: 133px; height: 160px;"
                :class="getSectionClass('01')" @click="openModalDetails('01')"   >
                PATIO 1
              </div>


              <div class="factory-section" style="top: 309px; left: 258px; width: 237px; height: 77px; bottom: 200px;"
                :class="getSectionClass('M14')" @click="openModalDetails('M14')"  >
                M14
              </div>

              <div class="factory-section" style="top: 309px; left: 523px; width: 40px; height: 77px;"
                :class="getSectionClass('M15')" @click="openModalDetails('M15')"  >
                M15
              </div>

              <div class="factory-section" style="top: 239px; left: 521px; width: 40px; height: 40px;"
                :class="getSectionClass('M16')" @click="openModalDetails('M16')"  >
                M16
              </div>


              <div class="factory-section" style="top: 412px; left: 172px; width: 120px; height: 40px;"
                :class="getSectionClass('M9')" @click="openModalDetails('M9')"  >
                M9
              </div>

              <div class="factory-section" style="top: 461px; left: 172px; width: 120px; height: 40px;"
                :class="getSectionClass('M8')"  @click="openModalDetails('M8')"  >
                M8
              </div>


              <!-- Bottom row M sections -->
              <div class="factory-section" style="top: 412px; left: 320px; width: 100px; height: 73px;"
                :class="getSectionClass('M7')" @click="openModalDetails('M7')"  >
                M7
              </div>


              <div class="factory-section" style="top: 412px; left: 463px; width: 32px; height: 40px;"
                :class="getSectionClass('M6')" @click="openModalDetails('M6')"  >
                M6
              </div>

              <div class="factory-section" style="top: 412px; left: 425px; width: 32px; height: 40px; bottom: 120px;"
                :class="getSectionClass('M5')" @click="openModalDetails('M5')" >
                M5
              </div>

              <div class="factory-section" style="top: 412px; left: 523px; width: 60px; height: 61px;"
                :class="getSectionClass('M4')" @click="openModalDetails('M4')" >
                M4
              </div>

              <div class="factory-section" style="left: 591px; width: 40px; height: 61px; top: 412px;"
                :class="getSectionClass('M3')" @click="openModalDetails('M3')"  >
                M3
              </div>

              <div class="factory-section" style="left: 639px; width: 40px; height: 61px; top: 412px;"
                :class="getSectionClass('M2')"   @click="openModalDetails('M2')">
                M2
              </div>


              <div class="factory-section" style="left: 689px; width: 40px; height: 61px; top: 412px;"
                :class="getSectionClass('M1')" @click="openModalDetails('M1')">
                M1
              </div>

              <!-- Triángulo rectángulo con ángulo recto en esquina inferior izquierda -->
              <div class="factory-section triangle"  
                style="top: 39px; left: 683px; width: 100px; height: 70px;" data-v-7c64df1f="" >
                <svg width="100%" height="100%" data-v-7c64df1f="" viewBox="0 0 100 70">
                  <polygon  stroke="#6c757d" stroke-width="2" data-v-7c64df1f="" points="0,70 0,0 100,70" :class="getSectionClass('M29')"  @click="openModalDetails('M29')">
                  </polygon>
                  <text y="50" text-anchor="middle" class="section-text" data-v-7c64df1f="" x="50">M29</text>
                  <!-- Ajusta la posición del texto -->
                </svg>
              </div>

              <div class="factory-section triangle"
                style="top: 141px; left: 786px; width: 70px; height: 50px;" data-v-7c64df1f="">
                <svg width="100%" height="100%" data-v-7c64df1f="" viewBox="0 0 70 50">
                  <polygon fill="#ffffff" stroke="#6c757d" stroke-width="2" data-v-7c64df1f="" points="0,50 0,0 70,50" :class="getSectionClass('M28')"  @click="openModalDetails('M28')">
                  </polygon>
                  <text y="35" text-anchor="middle" class="section-text" data-v-7c64df1f="" x="35">M28</text>
                  <!-- Ajusta la posición del texto -->
                </svg>
              </div>

              <div class="factory-section triangle status-unassigned"
                style="top:286px;left:929px;width:70px;height:50px;" data-v-7c64df1f="">
                <svg width="100%" height="100%" data-v-7c64df1f="" viewBox="0 0 70 50">
                  <polygon fill="#ffffff" stroke="#6c757d" stroke-width="2" data-v-7c64df1f="" points="0,0 70,0 0,50" :class="getSectionClass('M32')"  @click="openModalDetails('M32')">
                  </polygon>
                  <text y="35" text-anchor="middle" class="section-text" data-v-7c64df1f="" x="35" >M32</text>
                  <!-- Ajusta la posición del texto -->
                </svg>
              </div>




            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

     <div class="modal fade" id="modalDetails" tabindex="-1" aria-labelledby="furnaceBurnModalLabel"
      aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title" id="furnaceBurnModalLabel">Detalles de bodega - Stock total: {{ details?.stock_total??0 }}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>

          <div class="modal-body">

            <table class="table">
              <thead>
                <tr>
                  <th style="padding: 0.5rem 0.5rem !important;">Nombre de Inventario</th>
                  <th class="text-center" style="padding: 0.5rem 0.5rem !important;">Cantidad</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="bodega in details.bodegas_inventory" :key="bodega.id">
                  <td>{{ bodega.inventory.name }}</td>
                  <td class="text-center">{{ bodega.quantity }}</td>
                </tr>
              </tbody>
            </table>
            
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModalDetails">Cerrar</button>
          </div>
        </div>
      </div>
    </div>

</template>

<script>

import { Modal } from 'bootstrap';

export default {
  name: 'Map',
  data() {
    return {
      sectionStatus: {
        HORNO1: 'unassigned',
        HORNO2: 'unassigned',
        HORNO3: 'unassigned',
        HORNO4: 'unassigned',
        HORNO5: 'unassigned',
        HORNO6: 'unassigned',
        LIMPIEZA_TORNO: 'available',
        M1: 'unassigned',
        M10: 'unassigned',
        M11: 'unassigned',
        M12: 'unassigned',
        M13: 'unassigned',
        M14: 'unassigned',
        M15: 'unassigned',
        M16: 'unassigned',
        M2: 'unassigned',
        M20: 'unassigned',
        M21: 'unassigned',
        M22: 'unassigned',
        M23: 'unassigned',
        M24: 'unassigned',
        M25: 'unassigned',
        M26: 'unassigned',
        M27: 'unassigned',
        M28: 'unassigned',
        M29: 'unassigned',
        M3: 'unassigned',
        M33: 'unassigned',
        M4: 'unassigned',
        M5: 'unassigned',
        M6: 'unassigned',
        M7: 'unassigned',
        M9: 'unassigned', // si falta, puedes eliminar esta línea
        OFICINA_PROD: 'occupied',
        SEC1: 'unassigned',
        SEC2: 'unassigned',
        SEC3: 'unassigned',
        SEC4: 'unassigned',
        TALLER: 'unassigned',
        turbina: 'unassigned'
      },
      details:[],
      modalDetails: null,
    };
  },
  methods: {
    openModalDetails(idd) {
      this.details = this.bodegas.find(h => h.code === idd);
      const modalElement = document.getElementById('modalDetails');
      this.modalDetails = new Modal(modalElement); // Guarda la instancia del modal
      this.modalDetails.show(); // Muestra el modal
    },
    closeModalDetails() {
      // Cerrar modal usando Bootstrap
      if (this.modalDetails) {
        this.modalDetails.hide(); // Cierra el modal
      }
    },
    async getBodegas() {
      this.bodegas = await this.$store.dispatch('bodegas/getAll');
      this.bodegas.forEach(bodega => {
        this.toggleStatus(bodega?.code, bodega?.stock_total);
      });
    },

    toggleStatus(sectionId, stock) {

      if(stock<=0){
         this.sectionStatus[sectionId] = 'available';
      }
      if(stock>0){
         this.sectionStatus[sectionId] = 'occupied';
      }
    },

    resetAll() {
      Object.keys(this.sectionStatus).forEach(key => {
        this.sectionStatus[key] = 'unassigned';
      });
    },

    getSectionClass(sectionId) {
      const status = this.sectionStatus[sectionId];
      switch (status) {
        case 'occupied': return 'status-occupied';
        case 'available': return 'status-available';
        default: return 'status-unassigned';
      }
    },

   
  },
  mounted() {
    this.getBodegas();
  }
};
</script>

<style scoped>
.factory-container {
  position: relative;
  width: 100%;
  height: 600px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 8px;
  overflow: hidden;
  border: 2px solid #dee2e6;
}

.factory-section {
  position: absolute;
  border: 2px solid #6c757d;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 600;
  text-align: center;
  user-select: none;
}

.factory-section:hover {
  opacity: 0.8;
  transform: scale(1.02);
}

.factory-section.circular {
  border-radius: 50%;
}

.factory-section.triangle {
  border: none;
  background: transparent;
}

.factory-section.taller {
  background-color: #fd7e14 !important;
  color: white;
}

.status-occupied {
  background-color: #dc3545;
  color: white;
  fill: #dc3545;
}

.status-available {
  background-color: #28a745;
  color: white;
  fill:#28a745;
}

.status-unassigned {
  background-color: #ffffff;
  color: #495057;
  fill: #ffffff;
}

.section-text {
  font-size: 10px;
  font-weight: 600;
  fill: #495057;
}

.pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.page-item {
  margin: 0 5px;
}

.active {
  font-weight: bold;
}
</style>